import { useEffect, useRef, useState } from "react";
import "./App.css";

export default function App() {
  const [yesScale, setYesScale] = useState(1);
  const [hasConfetti, setHasConfetti] = useState(false);
  const [sessionKey, setSessionKey] = useState(0); // 🔁 hard reset key

  const noBtnRef = useRef(null);
  const containerRef = useRef(null);
  const confettiRef = useRef([]);

  const userId = useRef(
    localStorage.getItem("promUser") ?? crypto.randomUUID()
  );

  useEffect(() => {
    localStorage.setItem("promUser", userId.current);
  }, []);

  // Cleanup on unmount / reset
  useEffect(() => {
    return () => {
      confettiRef.current.forEach(c => c.remove());
      confettiRef.current = [];
    };
  }, []);

  const launchConfetti = () => {
    if (hasConfetti) return;
    setHasConfetti(true);

    const created = [];

    for (let i = 0; i < 120; i++) {
      const confetti = document.createElement("div");
      confetti.className = "confetti";
      confetti.style.backgroundColor = `hsl(${Math.random() * 360}, 100%, 60%)`;
      confetti.style.left = `${Math.random() * window.innerWidth}px`;
      document.body.appendChild(confetti);

      const animation = confetti.animate(
        [
          { transform: "translateY(0) rotate(0deg)" },
          {
            transform: `translateY(${window.innerHeight + 40}px) rotate(${Math.random() * 720}deg)`
          }
        ],
        {
          duration: 2500 + Math.random() * 2000,
          easing: "ease-out"
        }
      );

      animation.onfinish = () => {
        confetti.remove();
        confettiRef.current = confettiRef.current.filter(c => c !== confetti);
      };

      created.push(confetti);
    }

    confettiRef.current.push(...created);
  };

  const resetPage = () => {
    confettiRef.current.forEach(c => c.remove());
    confettiRef.current = [];
    setHasConfetti(false);
    setYesScale(1);
    setSessionKey(k => k + 1); // 🔥 FULL RESET
  };

  const handleYes = () => {
    launchConfetti();

    fetch("https://formspree.io/f/abcdwxyz", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event: "YES_CLICKED",
        userId: userId.current,
        time: new Date().toISOString(),
        device: navigator.userAgent
      })
    }).catch(() => {});

    alert("YAY! 🎉💃🕺");

    setTimeout(resetPage, 3500);
  };

  const handleNoHover = () => {
    const container = containerRef.current;
    const btn = noBtnRef.current;
    if (!container || !btn) return;

    const c = container.getBoundingClientRect();
    const b = btn.getBoundingClientRect();

    const noScale = Math.max(0.5, 1 - (yesScale - 1) * 0.4);
    const maxX = c.width - b.width * noScale;
    const maxY = c.height - b.height * noScale;

    btn.style.position = "absolute";
    btn.style.left = `${Math.random() * Math.max(maxX, 0)}px`;
    btn.style.top = `${Math.random() * Math.max(maxY, 0)}px`;

    setYesScale(s => Math.min(s + 0.2, 3.5));
  };

  const noScale = Math.max(0, 1 - (yesScale - 1) * 0.4);

  return (
    <div className="wrapper" key={sessionKey}>
      <div className="card">
        <h1>Will you go to prom with me? 💖</h1>

        <div className="buttons" ref={containerRef}>
          <button
            className="yes"
            style={{ transform: `scale(${yesScale})` }}
            onClick={handleYes}
          >
            Yes
          </button>

          <button
            className="no"
            ref={noBtnRef}
            style={{
              transform: `scale(${noScale})`,
              opacity: noScale > 0.1 ? 1 : 0,
              display: noScale > 0 ? "block" : "none"
            }}
            onMouseEnter={handleNoHover}
            onTouchStart={handleNoHover}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}
